﻿(function($, document) {
    $(document).ready(function () {
        $('.fa-findBtn').click(function (e) {

            if ($('.error-summary').is(':visible')) {
                var valGroup = $(this).data('validation-group');
                validateOnClick(valGroup);
            }

            var postcode = $('.fa-postcode').val();
            //var houseNo = $('.fa-houseNo').val();

            if (postcode.match(/^[a-zA-Z]{1,2}[0-9][0-9A-Za-z]{0,1} {0,1}[0-9][A-Za-z]{2}$/)) {
                $.ajax({
                    url: '/api/AddressFinder/FindByPostcode',
                    type: 'POST',
                    contentType: 'application/json;',
                    dataType: 'json',
                    //data: '{ postcode: "' + postcode + '", houseNumber: "' + houseNo + '" }',
                    data: '{ postcode: "' + postcode + '" }',
                    success: function (data) {
                        if (data != null && data.length == 1) {
                            selectAddress(data[0]['id']);
                        }
                        else if (data != null && data.length > 0) {
                            $('#modalTitle').show();
                            $('#addressList').empty();
                            for (var i = 0; i < data.length; i++) {
                                $('#addressList').append('<li><a href="#" onclick="selectAddress(' + data[i].id + ')">' + data[i].description + '</a></li>');
                            }
                            $('#registerModal').foundation('reveal', 'open');
                        }
                        else {
                            $('#modalTitle').hide();
                            $('#addressList').empty().append('<li>Sorry, no address found. Please enter your address manually</li>');
                            $('#registerModal').foundation('reveal', 'open');
                        }
                    }
                });
            } else {
                $('#modalTitle').hide();
                $('#addressList').empty().append('Please enter a valid postcode');
                $('#registerModal').foundation('reveal', 'open');
            }

            return false;
        });

    });
})(jQuery, document);

window.selectAddress = function(addressId) {
    $.ajax({
        url: '/api/AddressFinder/GetAddress',
        type: 'POST',
        contentType: 'application/json;',
        dataType: 'json',
        data: '{ addressId: "' + addressId + '" }',
        success: function (data) {
            $('.fa-houseNo').val(data['houseNo']);
            $('.fa-houseName').val(data['houseName']);

            if (data['company'].length > 0) {
                if (data['line3'].length > 0) {
                    // Address line 3 exists so stick company and line 1 on line 1
                    $('.fa-address1').val(data['company'] + ', ' + data['line1']);
                    $('.fa-address2').val(data['line2']);
                    $('.fa-address3').val(data['line3']);
                } else {
                    // No address line 3 so put company, line 1, line 2
                    $('.fa-address1').val(data['company']);
                    $('.fa-address2').val(data['line1']);
                    $('.fa-address3').val(data['line2']);
                }
            } else {
                // No company name so line 1, 2, 3
                $('.fa-address1').val(data['line1']);
                $('.fa-address2').val(data['line2']);
                $('.fa-address3').val(data['line3']);
            }


            $('.fa-town').val(data['town']);
            $('.fa-county').val(data['county']);
            $('.fa-postcode').val(data['postcode']);
        }
    });
    $('#registerModal').foundation('reveal', 'close');
}